import React from 'react';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../common/icon';
import InvoiceAction from './InvoiceAction';

const InvoiceActions = ({ invoice, performAction, setAction, isPaymentInfoSetup }) => {
  const isAnyActionAvailable = !!invoice.availableActions.length;
  if (!isAnyActionAvailable) {
    return null;
  }

  const canRetry = invoice.availableActions.includes(InvoiceAction.retryCharge);
  const canMarkAsPaid = invoice.availableActions.includes(InvoiceAction.retryCharge);
  const canMarkUncollectible = invoice.availableActions.includes(InvoiceAction.markUncollectible);
  const canChangePaymentMethod = invoice.availableActions.includes(InvoiceAction.modifyPaymentMethod);
  const canChangeDueDate = invoice.availableActions.includes(InvoiceAction.changeDueDate);
  const canRefund = invoice.availableActions.includes(InvoiceAction.refund);

  return (
    <div
      className="u-position-relative c-membership-actions-container"
      data-automation-id={`membership-invoice-actions-${invoice.id}`}
    >
      <Icon
        glyph={GLYPHS.membershipsOptions}
        className="u-mr u-cursor-pointer"
      />
      <div className="c-membership-actions">
        <button
          display-if={canRetry}
          type="button"
          className="c-membership-actions-option"
          onClick={() => (isPaymentInfoSetup ?
              performAction(invoice, InvoiceAction.retryCharge)
              : setAction(invoice, InvoiceAction.setupPaymentInfo)
          )}
        >
          Retry Charge
        </button>
        <button
          display-if={canChangePaymentMethod}
          type="button"
          className="c-membership-actions-option"
          onClick={() => setAction(invoice, InvoiceAction.modifyPaymentMethod)}
        >
          Modify payment method
        </button>
        <button
          display-if={canMarkAsPaid}
          type="button"
          className="c-membership-actions-option"
          onClick={() => performAction(invoice, InvoiceAction.markAsPaid)}
        >
          Mark as paid
        </button>
        <button
          display-if={canMarkUncollectible}
          type="button"
          className="c-membership-actions-option"
          onClick={() => performAction(invoice, InvoiceAction.markUncollectible)}
        >
          Uncollectible
        </button>
        <button
          display-if={canChangeDueDate}
          type="button"
          className="c-membership-actions-option"
          onClick={() => setAction(invoice, InvoiceAction.changeDueDate)}
        >
          Change due date
        </button>
        <button
          display-if={canRefund}
          type="button"
          className="c-membership-actions-option"
          onClick={() => (isPaymentInfoSetup ?
              performAction(invoice, InvoiceAction.refund)
              : setAction(invoice, InvoiceAction.setupPaymentInfo)
          )}
        >
          Refund
        </button>
      </div>
    </div>
  );
};

InvoiceActions.propTypes = {
  performAction: PropTypes.func.isRequired,
  setAction: PropTypes.func.isRequired,
  invoice: PropTypes.object.isRequired,
  isPaymentInfoSetup: PropTypes.bool.isRequired,
};

export default InvoiceActions;
